import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#1E40AF] hover:bg-[#1e3a8a] text-white shadow-lg shadow-blue-900/20 hover:shadow-blue-900/30 ring-blue-500',
    secondary: 'bg-orange-500 hover:bg-orange-600 text-white shadow-lg shadow-orange-500/20 ring-orange-500',
    outline: 'border-2 border-[#1E40AF] text-[#1E40AF] hover:bg-blue-50 ring-blue-500',
    ghost: 'text-gray-600 hover:text-[#1E40AF] hover:bg-blue-50 ring-blue-500'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-base px-6 py-3',
    lg: 'text-lg px-8 py-4',
    xl: 'text-xl px-10 py-5'
  };
  const width = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} ${className}`} {...props} data-id="element-418">
      {children}
    </motion.button>;
}